import React from 'react';
import { Field } from 'react-final-form';

import SwitchInput from '../utils/SwitchInput';

const SwitchField = React.memo( ( {
  field, validate, value, name, ...rest
} ) => {
  if ( field ) {
    return (
      <Field name={field} validate={validate} type="checkbox">
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && meta.submitError );
          return (
            <SwitchInput
              {...input}
              {...rest}
              value={input.value}
              inputOnChange={input.onChange}
              inputName={input.name}
              meta={meta}
              isInvalid={isInvalid}
            />
          );
        }}
      </Field>
    );
  }
  return (
    <SwitchInput
      {...rest}
      value={value}
      inputName={name}
    />
  );
} );

export default SwitchField;
